<template>
  <div class="widget-view"
       :style="{
          'display':'flex',
          'align-items': 'center',
          'justify-content': viewProps.textAlign,
          'font-size': this.$util.num2px(viewProps.fontSize),
          'font-weight': viewProps.fontWeight,
          'color': viewProps.color}">
    <pre>{{ viewProps.dataConfig.data }}</pre>
  </div>
</template>

<script>
import ApiDesignApi from "@/api/datasvc/apiDesign.api";

export default {
  name: 'WidgetTitleView',
  components: {},
  data() {
    return {}
  },
  props: {
    widgetProps: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    viewProps() {
      return this.widgetProps.viewProps;
    },
    datasourceProps() {
      return this.widgetProps.datasourceProps;
    }
  },
  watch: {
    'widgetProps.datasourceProps': {
      handler: function (val) {
        this.handleFetchData().then(data => this.handleFillData(data)).then(() => {
        });
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.handleFetchData().then(data => this.handleFillData(data)).then(() => {
    });
  },
  methods: {
    /**
     * 获取数据
     */
    handleFetchData() {
      return new Promise((resolve, reject) => {
        if (this.datasourceProps.datasourceType === 'STATIC') {
          let respData = this.datasourceProps.dataConfig[this.datasourceProps.datasourceType].data;
          resolve(respData);
        } else if (this.datasourceProps.datasourceType === 'API') {
          let dataConfig = this.datasourceProps.dataConfig[this.datasourceProps.datasourceType];
          if (dataConfig && dataConfig.datasource) {
            let reqParams = (typeof dataConfig.reqParams === 'string') ? JSON.parse(dataConfig.reqParams) : dataConfig.reqParams;
            ApiDesignApi.runApi(dataConfig.datasource, reqParams).then(resp => {
              console.log(`======${this.$route.name} respData====>`, resp);
              resolve(resp.data);
            });
          } else {
            reject();
          }
        } else {
          reject();
        }
      });
    },

    /**
     * 填充数据 {a: '1', b:21, c: 33},{a: '11', b:221, c: 133} / data
     * @param respData
     */
    handleFillData(respData) {
      console.log("----title---->", respData);
      let dataList = (typeof respData === 'string') ? JSON.parse(respData) : respData;
      let mapping = this.datasourceProps.dataMapping.find(item => item.prop === 'text');
      this.viewProps.dataConfig.data = respData[mapping.field];
    }
  }
}

</script>
<style lang="less" scoped>
.widget-view {
  width: 100%;
  height: 100%;
}
</style>
